import { useBwicTableContext } from '@/creditflowresearch/application/Bonds/BwicTableContext';
import { useFiltersContext } from '@/creditflowresearch/application/FiltersContext';
import Bwic from './Bwic';

const BwicContainer = (props) => {
  const {
    bwicsData: { bwics: { collection: data, totalCount } },
    isBwicFetching: isFetching,
  } = useBwicTableContext();

  const {
    handlePageChange,
    handlePerPageChange,
    handleSortChange,
    params: {
      page,
      perPage,
      sortBy,
      sortOrder,
    },
  } = useFiltersContext();

  return (
    <Bwic
      { ...props }
      isFetching={ isFetching }
      data={ data }
      totalCount={ totalCount }
      page={ page }
      perPage={ perPage }
      sortBy={ sortBy }
      sortOrder={ sortOrder }
      paginate={ handlePageChange }
      itemsPerPage={ handlePerPageChange }
      sort={ handleSortChange }
    />
  );
};

export default BwicContainer;
